import { customRegionNamesDict } from '@monoimin/intl';

import { getRegionNameByCode } from './getRegionNameByCode';

import type { DataSourceEntry, Locales } from '@monoimin/sb-types';

/**
 * Обработка кастомных значений imin-countries datasource
 *
 * @param value - Значение объекта datasource
 * @param locale - Язык
 * @returns Возваращает локализированное значение объекта datasource в виде строки
 */
const getCustomName = (value: string, locale: Locales) => {
  const dict = customRegionNamesDict[locale];
  return dict?.[value] || dict?.[value?.toUpperCase()];
};

const getName = (value: string, locale: Locales) => {
  try {
    const regionNameByCountryCode = getRegionNameByCode(locale);

    return regionNameByCountryCode.of(value);
  } catch {
    return undefined;
  }
};

export function getCountryName(
  datasourceEntry: DataSourceEntry | string | number | undefined,
  locale: Locales,
  datasource?: DataSourceEntry[]
) {
  if (typeof datasourceEntry === 'number' || !datasourceEntry) {
    return undefined;
  }

  const value =
    typeof datasourceEntry === 'string'
      ? datasourceEntry
      : datasourceEntry.value;

  const customName = getCustomName(value, locale);

  if (customName) {
    return customName;
  }

  if (Array.isArray(datasource) && datasource.length > 0) {
    const currentDatasourceEntry = datasource.find(
      (el) => el.dimension_value === value || el.value === value
    );

    return getName(currentDatasourceEntry?.value ?? value, locale);
  }

  if (value) {
    return getName(value, locale);
  }

  return undefined;
}

export default getCountryName;
